// Copyright (c) 2016 Deere & Company

import Report, {getDefaultState} from '../../responsible-dealer/state/report';
import actions from '../../actions-list';

const updateResponsibleDealerReport = (state, action) =>
    Report.update(state, {
        $set: action.data
    });

export default (state = getDefaultState(), action) => {

    const actionTypes = {
        [actions.CREATE_RESPONSIBLE_DEALER_REPORT_SUCCESS]: updateResponsibleDealerReport,
        [actions.RESET_REPORT_SEARCH_RESULTS]: updateResponsibleDealerReport
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/reports/responsible-dealer/reducers/report.js